import { User } from "@app/core/types";

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface AuthToken {
  token: string;
  refreshToken: string;
  expiresAt: Date;
}

export interface AuthState {
  user: User | null;
  token: AuthToken | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

export interface LoginPayload {
  companyNumber: number;
  userName: string;
  password: string;
}

export interface ResetPasswordPayload {
  id: string;
  companyNumber: number;
  newPassword: string;
}

export interface LoginResponse {
  success: boolean;
  cookieBind?: string;
  isTwoFactorEnabled: boolean;
}

export interface TwoFactorSetupResponse {
  secretKey: string;
  userName: string;
  companyNumber: string;
  barcodeUrl: string;
  code: number;
  isNew: boolean;
  password: string;
  returnURL: string;
}

export type LoginResult = | { status: 'Success'; user: User } | { status: 'TwoFactorRequired' };
